import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const FooterHeader = styled.div`
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
    max-width: 50%;
    padding: ${rem(12)} ${rem(16)};
    font-weight: bold

`;
export const FooterWrapper = styled.div`
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
    max-width: 50%;
    display: flex;
    flex-direction: row;
    align-items: start;
    padding: ${rem(12)} ${rem(16)};
    line-height: ${rem(20)};
    text-align: start;
    gap: 24px
`;